import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HomeSchema from "@/components/home/HomeSchema";
import GlossarySchema from "@/components/seo/GlossarySchema";

// Lazy load all below-fold sections to reduce initial JS
const StatsSection = lazy(() => import("@/components/StatsSection"));
const SmartCalculatorPromo = lazy(() => import("@/components/home/SmartCalculatorPromo"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const TechnologySection = lazy(() => import("@/components/TechnologySection"));
const ProductsPreviewSection = lazy(() => import("@/components/ProductsPreviewSection"));
const IndustriesSection = lazy(() => import("@/components/IndustriesSection"));
const WhyRameonSection = lazy(() => import("@/components/home/WhyRameonSection"));
const TrustEngineeringSection = lazy(() => import("@/components/home/TrustEngineeringSection"));
const ProcessFlowSection = lazy(() => import("@/components/home/ProcessFlowSection"));
const SustainabilitySection = lazy(() => import("@/components/SustainabilitySection"));
const BlogPreviewSection = lazy(() => import("@/components/home/BlogPreviewSection"));
const HomeFAQSection = lazy(() => import("@/components/home/HomeFAQSection"));
const FinalCTASection = lazy(() => import("@/components/home/FinalCTASection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));
const WhatsAppButton = lazy(() => import("@/components/WhatsAppButton"));
const FloatingZLDButton = lazy(() => import("@/components/FloatingZLDButton"));
const SideNavigation = lazy(() => import("@/components/SideNavigation"));
const BackToTop = lazy(() => import("@/components/BackToTop"));
const StickyMobileCTA = lazy(() => import("@/components/home/StickyMobileCTA"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <HomeSchema />
      <GlossarySchema />
      <Header />
      <main>
        <section id="hero">
          <HeroSection />
        </section>
        <Suspense fallback={null}>
          <StatsSection />
          <SmartCalculatorPromo />
          <section id="about">
            <AboutSection />
          </section>
          <section id="technology">
            <TechnologySection />
          </section>
          <section id="products">
            <ProductsPreviewSection />
          </section>
          <IndustriesSection />
          <WhyRameonSection />
          <TrustEngineeringSection />
          <ProcessFlowSection />
          <SustainabilitySection />
          <BlogPreviewSection />
          <HomeFAQSection />
          <FinalCTASection />
          <section id="contact">
            <ContactSection />
          </section>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <WhatsAppButton />
        <FloatingZLDButton />
        <SideNavigation />
        <BackToTop />
        <StickyMobileCTA />
      </Suspense>
      {/* Bottom spacer so content isn't hidden behind sticky mobile CTA */}
      <div className="lg:hidden h-20" aria-hidden="true" />
    </div>
  );
};

export default Index;
